export default __webpack_public_path__ + "static/media/underConstruction.c0fb311c.png";